import send from '@components/competitions/levels/tekyehmajazi/assets/images/t0/send.webp';
import success from '@components/competitions/levels/tekyehmajazi/assets/images/t0/success.webp';
import {appConfig} from '@config';
import {useCompetitionTekyehmajaziContext} from '@context/CompetitionTekyehmajaziContext';
import {Box, CircularProgress, useTheme} from '@mui/material';
import axios from 'axios';
import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';

type IProps = {
	state?: string
}

type LastData = {
	competition: number;
	phone: string;
	day: number;
	answers: {[key: string]: number | null};
	correctAnswers: number[];
}
export default function Phone(props: IProps) {
	const {state} = props;
	const theme = useTheme();
	const {t} = useTranslation();
	const [loading, setLoading] = useState(false);
	const [phoneValid, setPhoneValid] = useState<boolean | null>(null);
	const {
		phone,
		setPhone,
		day,
		setDay,
		answers,
		setAnswers,
		correctAnswers,
		setCorrectAnswers,
		setMission
	} = useCompetitionTekyehmajaziContext();
	useEffect(() => {
		setTimeout(() => {
			if (loading) {
				setLoading(false);
			}
		}, 10000);
	}, [loading]);
	const sendData = useCallback(async (lastData: LastData) => {
		try {
			if (isValidPhoneNumber(phone)) {
				setLoading(true);
				setPhoneValid(true);
				const res = await axios({
					url: `${appConfig.competition2.url}tekyehmajazi`,
					method: 'POST',
					data: lastData
				});
				
				if (res.data.success) {
					setMission(2);
					localStorage.setItem('competitionDay', String(lastData.day));
				} else {
					console.log('err');
					setLoading(false);
				}
			} else {
				setLoading(false);
				setPhoneValid(false);
			}
		} catch (err) {
			setLoading(false);
		}
	}, [phone]);
	
	function sendDataObject() {
		let lastData = {
			competition: 3,
			day: day,
			phone,
			answers,
			correctAnswers
		};
		sendData(lastData);
	}
	
	return (
		<>
			{/*<div className="flex flex-col w-full h-80 justify-center items-center gap-y-3">*/}
			{/*	<img className="w-3/6" src={title} alt="title"/>*/}
			{/*</div>*/}
			<div className="chat-words-choice flex flex-col justify-start mt-5">
				<div>
					<Box className="flex flex-col w-full gap-y-5 items-center justify-center">
						<div className="flex flex-row w-9/12">
							<div className="flex-1 rounded-3xl flex justify-center items-center">
								<img src={success} alt={'answer1'} className="w-full"/>
							</div>
						</div>
					</Box>
					<Box className="flex flex-row w-11/12 cursor-pointer rtl m-auto mt-10">
						{/*<input className="phone-input w-full h-12 p-5 rounded-3xl rtl text-center" placeholder="شماره موبایل"/>*/}
						{/*<PhoneInput
						 inputProps={{
						 name: 'phone',
						 required: true,
						 autoFocus: true
						 }}
						 preferredCountries={['ir']}
						 country={'ir'}
						 autoFormat={true}
						 disableDropdown={true}
						 disableCountryCode={true}
						 disableSearchIcon={true}
						 // countryCodeEditable={false}
						 value={value}
						 onChange={() => setValue}
						 masks={{ir: '(....) ...-.-...'}}
						 />*/}
						<PhoneInput
							// countrySelectProps={{ unicodeFlags: true }}
							international={true}
							placeholder="شماره موبایل"
							// country="IR"
							defaultCountry="IR"
							value={phone}
							onChange={(phoneNumber) => setPhone(phoneNumber as string)}
							limitMaxLength={true}
							className={`phone-input w-10/12 h-12 p-5 rounded-3xl ltr text-center m-auto ${phoneValid == false ? 'phone-input-error border-red-800 bg-[#efb2b2]' : 'border-[#004038] bg-[#004038]'}`}
						/>
					</Box>
					{
						!loading && (
							<Box className="w-full flex mt-1 justify-center">
								<div
									className="w-7/12 h-8 rounded-3xl flex text-center items-center justify-center cursor-pointer">
									<img src={send} alt={'send'} className="w-3/6" onClick={sendDataObject}/>
								</div>
							</Box>
						)
					}
					{
						loading && (
							<div className="w-full flex justify-center my-10">
								<CircularProgress sx={{
									color: '#0b152b'
								}}/>
							</div>
						)
					}
				</div>
			</div>
		</>
	);
}
